import type { IRemoteView, TVerification, TFrameOptions, IRunPlan } from '../types';
import { logError } from '../services/log';

import hifVersion from '../verifications/hif_version';
import frameSettings from '../verifications/frame_settings';

const R = {
  doubleSlashes: /\/+/g
};

const verificationsDb: Record<
  string,
  (verification: TVerification, runPlan: IRunPlan<IRemoteView>, frameOptions: TFrameOptions) => void
> = {
  frame_settings: frameSettings,
  hif_version: hifVersion
};

/**
 * create a run plan from a frame
 */
export class VerificationBuilder {
  /**
   * invoke all frame verifications
   *
   * @param runPlan
   * @returns
   */
  async verifySettings(frameOptions: TFrameOptions): Promise<IRunPlan> {
    return this.__runVerifications([{ id: 'frame_settings', settings: {} }], {} as IRunPlan, frameOptions);
  }

  /**
   * invoke all run plan verifications
   *
   * @param runPlan
   * @returns
   */
  async verifyRunPlan(runPlan: IRunPlan): Promise<IRunPlan> {
    return this.__runVerifications(runPlan.verifications ?? [], runPlan, {} as TFrameOptions);
  }

  /**
   * run all verifications for a step
   *
   * @param verifications
   * @param runPlan
   * @param frameOptions
   * @returns
   */
  private __runVerifications(verifications: TVerification[], runPlan: IRunPlan, frameOptions: TFrameOptions) {
    verifications.forEach((verification: TVerification) => {
      try {
        const { id, fn } = verification;
        const verify = id ? verificationsDb[id] : fn;

        if (verify) {
          verify(verification, runPlan, frameOptions);
        }
      } catch (e) {
        logError(e.toString());
      }
    });

    return runPlan;
  }
}
